import { testimonials } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function TestimonialsSection() {
  return (
    <section className="w-full bg-secondary-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="读者怎么说"
            title="围观的人给出的评价"
            description="我们把评论区的反馈整理在这里，好的坏的都保留，方便你判断这个站合不合口味。"
            align="center"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item, index) => (
            <Reveal key={item.id} delay={index * 70}>
              <figure className="flex h-full flex-col rounded-lg border border-secondary-200 bg-background-50 p-5">
                <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
                <blockquote className="mt-3 flex-1 font-body text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50">
                    {item.avatar}
                  </span>
                  <span className="min-w-0">
                    <span className="block truncate font-heading text-sm font-bold text-foreground-950">
                      {item.name}
                    </span>
                    <span className="block truncate font-label text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}